import { spawn, call, takeLatest, put, all } from 'redux-saga/effects';

// Actions
import { verificacionActions } from '../../../../application/actions/verificacion';

import { loadersActions } from '../../../../application/actions/ui_loaders';
// import { logReqError } from '../../../ui/utils/functions';

import api from '../../../api';

const apiVerificacion = api(process.env.REACT_APP_URL);

export function* fetchVerificacionFuncion(params) {
    try {
        let body = {};
        let endpoint = '';

        if ('trackId' in params.payload) {
            endpoint = 'evaluacion/consulta/datos-personales'
        }

        if ('solicitudAprobada' in params.payload) {
            endpoint = 'evaluacion/consulta/solicitud-aprobada'
        }

        let optionalsHeaders = {
          Authorization: `Bearer ${params.payload.trackId}`,
          track_id: params.payload.trackId,
        };

        // se incorpora tocken de captcha a la validacion
        if ('rut' in params.payload && 'serie' in params.payload) {
          body = {
            numeroSerie: params.payload.serie,
            rut: params.payload.rut,
          };

          optionalsHeaders = {
            Authorization: `${params.payload.tokenCaptcha}`,
          };

          endpoint = 'evaluacion/validar';
        }

        yield put(loadersActions.verificacionLoader({ isLoading: true }));

        const { data } = yield call(apiVerificacion.post, endpoint, body, optionalsHeaders);

        yield put(loadersActions.verificacionLoader({ isLoading: false }));

        if (data && 'code' in data && data.code !== 1) {
            if (endpoint === 'evaluacion/validar' && 'data' in data) {
                window.localStorage.setItem('track_id', data.data.token);
            }
            yield put(verificacionActions.validarCorrecto({ responseValidar: data })); 
        } else if (data && data.code === 1) {
            yield put(verificacionActions.validarError({ responseValidar: data }));
        } else {
            yield put(verificacionActions.validarError({ responseValidar: { code: -1 } }));
        } 

    } catch(error) {
        yield all([
            put(verificacionActions.validarError({ responseValidar: {} }))
        ]);
    }
}

export function* watchFetchVerificacion() {
    yield takeLatest(verificacionActions.verificacion.type, fetchVerificacionFuncion);
}

export default function* rootSaga() {
    yield spawn(watchFetchVerificacion);
}
